/**
 * The affirmative action — long, confirm, deposit.
 *
 * `.ce-btn-up` is the semantic up gradient plus its own green shadow
 * (neumorph2026.css §3), so this stays in step with every other "up" surface
 * on the page instead of carrying its own literal.
 *
 * `disabled` is forwarded. It was accepted at two call sites (the vault
 * deposit ticket, desktop and mobile) and dropped here, so a deposit with no
 * amount and no connected wallet still looked pressable and still fired.
 */
export const GreenButton = ({ text, onClick = () => {}, disabled, className = "" }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`ce-btn ce-btn-up ${className}`.trim()}
    >
      {text}
    </button>
  );
};
